<template>
    <!-- passar com props: id, name e funcao onDebounce (v-debounce:XXXms: callback a ser executado XXXms depois do usuario parar de digitar) -->
    <div class="col-12 col-md-4 mt-3 mt-md-0 pr-4 d-flex align-items-center">
        <input
            class="search-input w-100 mr-4"
            placeholder="Ex: Nome, data, extensão do arquivo..."
            v-model="inputData"
            type="text"
            :id="id"
            :name="name"
            v-debounce:500ms="onDebounce"
        >
        
        <i 
            v-if="inputData == ''"
            class="search-input-icon fal fa-search font-14 position-absolute"
        ></i>

        <i
            v-else
            ref="iconRef"
            @click="clearInputData"
            class="search-input-icon fal fa-times font-14 position-absolute cursor-pointer"
        ></i>
    </div>
</template>

<script>
import Vue from 'vue'
import vueDebounce from 'vue-debounce'

Vue.use(vueDebounce)

export default {
    name: 'SearchInput',
    props: {
        id: {
            type: String,
            required: false,
        },
        name: {
            type: String,
            required: false,
        },
        onDebounce: {
            type: Function,
            required: false,
        }
    },
    data() {
        return {
            inputData: ''
        }
    },
    methods: {
        clearInputData() {
            this.$emit('clearInputSearch');
            this.inputData = '';
        }
    },
    watch: {
        inputData(value) {
            this.$emit('inputValueChanged', value);
        }
    }
}
</script>

<style scoped>
    .rotate-out-2-cw{-webkit-animation:rotate-out-2-cw .6s cubic-bezier(.25,.46,.45,.94) both;animation:rotate-out-2-cw .6s cubic-bezier(.25,.46,.45,.94) both}
    .search-input {
        position: relative;
        background-color: transparent;
    }

    .search-input-icon {
        right: 3rem;
        top: 50%;
        transform: translateY(-50%);
    }
</style>



// WEBPACK FOOTER //
// src/components/atoms/SearchInput.vue